var urls = {
  REBATE_INIT: 'rebate/cross_index.php?ct=rebatev2&ac=init',// 红包初始化
  REBATE_USER: 'rebate/cross_index.php?ct=rebatev2&ac=user',// 红包用户信息
  REBATE_SHOW: 'rebate/cross_index.php?ct=rebatev2&ac=show',// 获取红包数据
  REBATE_RECEIVE: 'rebate/cross_index.php?ct=rebatev2&ac=receive',// 领取红包
  REBATE_RECEIVE_LOG: 'rebate/cross_index.php?ct=rebatev2&ac=receiveLog',// 红包领取记录
  REBATE_WXAUTH: 'rebate/cross_index.php?ct=rebatev2&ac=wxAuth',// 微信绑定二维码
  REBATE_EXCHANGELOG: 'rebate/cross_index.php?ct=rebatev2&ac=exchangeLog',// 兑换日志
  REBATE_EXCHANGE: 'rebate/cross_index.php?ct=rebatev2&ac=exchangeWx',// 兑换
  REBATE_EDITPASSWORD: 'common/cross_index.php?ct=user&ac=editPassword',// 修改密码
  REBATE_SEND: 'common/cross_index.php?ct=sms&ac=send',// 获取验证码
  REBATE_INFO: 'common/cross_index.php?ct=user&ac=info',// 用户信息接口
  PAY_DETAIL: 'common/cross_index.php?ct=user&ac=detail',//用户充值信息接口
  
}
export default urls


// WEBPACK FOOTER //
// ./src/network/urlsv2.js